module.exports = __webpack_public_path__ + "static/media/points-icon.dbfa7ba8.svg";